<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="row">
      <div class="col-3" v-if="$slots.icon || icon">
        <div class="info-icon text-center" :class="`icon-${type}`">
          <slot name="icon">
            <i :class="icon"></i>
          </slot>
        </div>
      </div>

      <div class="col-9" v-if="$slots.content || title || subTitle">
        <div class="numbers">
          <slot>
            <p v-if="subTitle" class="card-category">{{ subTitle }}</p>
            <h3 v-if="title" class="card-title">
              {{ title }}
            </h3>
          </slot>
        </div>
      </div>
    </div>

    <div class="stats" slot="footer">
      <slot name="footer" v-if="$slots.footer"></slot>

      <template v-if="Object.keys(filteredMap).length > 0">
        <div 
          v-for="(value1, key1) in filteredMap"
          :key="key1"
          class="">
          <p v-if="isShowSubTitle" class="card-category" style="font-size: 13.5px; font-weight: 800; margin-bottom: 4px">{{ formatKey(key1) }}</p>
          <div v-if="isShowBreakdownAfterSubTitle()" class="breakdown-item" style="font-size: 13.5px; font-weight: 800; margin-bottom: 16px;">
            <span class="breakdown-key">{{ "total" }}</span>
            <span class="breakdown-colon">:</span>
            <span class="breakdown-value"><strong>{{ value1.total_all || 0 }}</strong></span>
          </div>


          <div
            class="breakdown-container">
            <div
              v-for="(value2, key2) in Object.entries(value1)"
              v-show="isShowBreakdownItem(value2[0])"
              :key="key2"
              class="breakdown-item">
              <span class="breakdown-key">{{ formatKey(value2[0]) }}</span>
              <span class="breakdown-colon">:</span>
              <span class="breakdown-value"><strong>{{ value2[1] }}</strong></span>
            </div>
          </div>
          
          <hr style="width: 100% !important; margin: 12px auto 10px auto !important;">
        </div>
      </template>
      
    </div>
  </card>
</template>

<script>
import Card from './Card.vue';

export default {
  name: 'StatsCardBreakdown',
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    icon: String,
    title: String,
    subTitle: String,
    dataMap: {
      type: Object,
      default: () => ({}),
    },
    isShowSubTitle: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      default: '',
    },
    pixelType: {
      type: String,
      default: '',
    }
  },
  computed: {
    filteredMap() {
      const result = { ...this.dataMap };
      // The 'total' key is excluded as it's intended for the main title
      delete result.total;
      return result;
    },
  },
  methods: {
    isShowBreakdownAfterSubTitle() {
      return this.cardType == 'pixel' && ['pixel_impressions_all_visitors', 'pixel_impressions_unique_visitors'].includes(this.pixelType);
    },
    isShowBreakdownItem(itemKey) {
      return this.cardType != 'pixel' || itemKey != 'total_all';
    },
    formatKey(key) {
      // Replaces underscores with spaces for display
      return key.replace(/_/g, ' ');
    },
  },
};
</script>

<style scoped>
.card-stats .stats {
  color: var(--text-primary-color);
}

.breakdown-container {
  display: grid;
  /* This single line creates a responsive, wrapping column layout */
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px 16px; /* row-gap and column-gap */
  margin-top: 8px;
  width: 100%;
}

.breakdown-item {
  display: grid;
  grid-template-columns: auto auto 1fr;
  font-size: 13px;
  align-items: baseline;
  gap: 4px;
}

.breakdown-key {
  text-transform: capitalize;
  text-align: left;
  white-space: normal;
  word-break: break-word;
}

.breakdown-colon {
  text-align: center;
}

.breakdown-value {
  font-weight: 500;
  text-align: left;
}
</style>